import { Heart } from 'lucide-react';
import { Link } from 'wouter';

const KOFI_URL = 'https://ko-fi.com/healfm';

export function Footer() {
  return (
    <footer className="py-4 text-center flex flex-wrap items-center justify-center gap-3">
      <a
        href={KOFI_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1.5 text-sm text-parchment-400 dark:text-white/40 hover:text-parchment-text/70 dark:hover:text-white/60 transition-colors"
      >
        <Heart className="w-3.5 h-3.5" />
        Support heal.fm
      </a>
      <span className="text-parchment-400/40 dark:text-white/20">·</span>
      <a
        href="mailto:feedback@heal.fm"
        className="text-sm text-parchment-400 dark:text-white/40 hover:text-parchment-text/70 dark:hover:text-white/60 transition-colors"
      >
        Feedback
      </a>
      <span className="text-parchment-400/40 dark:text-white/20">·</span>
      <Link
        href="/privacy"
        className="text-sm text-parchment-400 dark:text-white/40 hover:text-parchment-text/70 dark:hover:text-white/60 transition-colors"
      >
        Privacy
      </Link>
    </footer>
  );
}
